import type { UserRole } from "./RoleContext";

export interface CatalogPermissions {
  view: boolean;
  edit: boolean;
}

const ROLE_CATALOG_PERMISSIONS: Record<UserRole, CatalogPermissions> = {
  super_admin: { view: true, edit: true },
  admin: { view: true, edit: true },
  owner: { view: false, edit: false },
  cfo: { view: false, edit: false },
  finance_manager: { view: false, edit: false },
  bookkeeper: { view: false, edit: false },
  ops_manager: { view: false, edit: false },
  warehouse_manager: { view: false, edit: false },
  head_of_installation: { view: false, edit: false },
  procurement_manager: { view: false, edit: false },
  inventory_manager: { view: false, edit: false },
  installer: { view: false, edit: false },
  subcontractor: { view: false, edit: false },
  sales: { view: false, edit: false },
  sales_manager: { view: false, edit: false },
  call_center: { view: false, edit: false },
  it_staff: { view: true, edit: true },
};

export function getCatalogPermissions(role: UserRole): CatalogPermissions {
  return ROLE_CATALOG_PERMISSIONS[role];
}
